
    import '/opt/buildhome/repo/packages/x/components/code-highlighter/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["code-highlighter-demo-basic","code-highlighter-demo-custom-header","code-highlighter-demo-with-xmarkdown","code-highlighter-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/code-highlighter/index.zh-CN.md?type=demo')
};